$('select[name="search_studentid"]').on('change', function () {
    window.location = base_url + 'eportfolio/students/report/?student=' + $(this).val();
});
